export const DEFAULT_DEBOUNCE_WAIT = 500;

export function debounce<F extends (...args: Parameters<F>) => ReturnType<F>>(func: F, waitFor?: number): (...args: Parameters<F>) => void {
	let timeout: NodeJS.Timeout;
	return (...args: Parameters<F>): void => {
		clearTimeout(timeout);
		timeout = setTimeout(() => func(...args), waitFor ?? DEFAULT_DEBOUNCE_WAIT);
	};
}
